<template>
    <div class="container-mob w-100">
        <img src="/assets/img/logo.png" class="img-fluid logo-header mb-2">
        <div class="form-login mt-2">
            <p class="color-red">¿Aún no estás registrado?</p>
            <h2 class="mb-3">Regístrate</h2>
            <div class="notification text-danger" v-if="errors">
                <ul>
                    <ul v-for="(fields, key) in errors">
                        <b>{{ key }}:</b>
                        <li v-for="error in fields">{{ error }}</li>
                    </ul>
                </ul>
            </div>
            <form method="post" @submit.prevent="register">
                <div class="input-group">
                    <span class="input-group-text" id="basic-addon1"><i class="fas fa-user"></i></span>
                    <input type="text" class="form-control" placeholder="Nombre" aria-label="Nombre" aria-describedby="basic-addon1" id="nombre" v-model="nombre">
                </div>
                <div class="input-group">
                    <span class="input-group-text" id="basic-addon5"><i class="fas fa-user"></i></span>
                    <input type="text" class="form-control" placeholder="Apellido" aria-label="Apellido" aria-describedby="basic-addon5" id="apellido" v-model="apellido">
                </div>
                <div class="input-group">
                    <span class="input-group-text" id="basic-addon3"><i class="fas fa-envelope"></i></span>
                    <input type="email" class="form-control" placeholder="Email" aria-label="Email" aria-describedby="basic-addon3" name="email" id="email" v-model="email">
                </div>
                <div class="input-group">
                    <span class="input-group-text" id="basic-addon2"><i class="fas fa-unlock-alt"></i></span>
                    <input type="password" class="form-control" placeholder="Contraseña" aria-label="Contraseña" aria-describedby="basic-addon2" name="password" id="password" v-model="password">
                </div>
                <div class="input-group">
                    <span class="input-group-text" id="basic-addon6"><i class="fas fa-unlock-alt"></i></span>
                    <input type="password" class="form-control" placeholder="Confirmar Contraseña" aria-label="Contraseña" aria-describedby="basic-addon6" id="password_confirmation" v-model="password_confirmation">
                </div>
                <div class="cuadro-legal"><p><em>MITSUBISHI ELECTRIC EUROPE, B.V., Sucursal en España, (en adelante "Mitsubishi Electric") es la responsable del tratamiento de sus datos para gestionar su solicitud acerca de los productos y/o servicios de Mitsubishi Electric. Puede ejercer sus derechos de protección de datos como se describe en la <a rel="noopener" target="_blank" href="https://emea.mitsubishielectric.com/es/privacy/index.html">Política de Privacidad</a>.</em></p></div>
                <div class="d-flex mt-2">
                    <input style="width: 13px; height: 13px;" class="me-2" type="checkbox" id="politica_privacidad" v-model="politica_privacidad">
                    <label for="politica_privacidad">He leído y acepto la <a href="https://emea.mitsubishielectric.com/es/privacy/index.html" target="_blank"> Política de Privacidad.</a> de <strong>MITSUBISHI ELECTRIC</strong> para el tratamiento de mis datos para los fines del formulario.</label>
                </div>
                <div class="d-flex mt-2">
                    <input style="width: 13px; height: 13px;" class="me-2 check-lg" type="checkbox" id="aviso_legal" v-model="aviso_legal">
                    <label for="aviso_legal">He leído, entendido, y ACEPTO el <a href="/aviso_legal.pdf" target="_blank">Aviso Legal y Términos y Condiciones de Uso de la Aplicación.</a></label>
                </div>
                <div class="d-flex mt-2">
                    <input style="width: 13px; height: 13px;" class="me-2 check-lg" type="checkbox" id="comunicaciones_comerciales" v-model="comunicaciones_comerciales">
                    <label for="comunicaciones_comerciales">He leído y consiento que <strong>MITSUBISHI ELECTRIC</strong> también utilice mis datos para comunicaciones comerciales y realización de encuestas. Véase más información en la <a href="https://emea.mitsubishielectric.com/es/privacy/index.html" target="_blank">Política de Privacidad.</a></label>
                </div>
                <div class="text-center mt-5">
                    <button type="button" class="btn-form" @click="register">REGÍSTRATE</button>
                </div>

            </form>
        </div>


    </div>


</template>

<script>
export default {
    data() {
        return {
            nombre: null,
            apellido: null,
            email: null,
            password: null,
            password_confirmation: null,
            politica_privacidad: false,
            aviso_legal: false,
            comunicaciones_comerciales: false,
            errors: null,
        };
    },
    methods: {
        register() {
            this.$store
            .dispatch("registerUserConsumo", {
                nombre: this.nombre,
                apellido: this.apellido,
                email: this.email,
                password: this.password,
                password_confirmation: this.password_confirmation,
                politica_privacidad: this.politica_privacidad,
                aviso_legal: this.aviso_legal,
                comunicaciones_comerciales: this.comunicaciones_comerciales,
            })
            .then(response => {
                this.$router.push({name: "dashboard"});
            })
            .catch(error => {
                this.errors = error.response.data.errors;
            });
        }
    }
};
</script>

<style>
.logo-header {
    max-width: 150px;
}

.input-group-text {
    background: #FAFAFA;
    border: none;
    border-radius: 0px;
    padding-top: 20px;
    padding-bottom: 20px;
    color: #989898;
    width: 40px;
    margin-left: auto;
    margin-right: auto;
}

.input-group > .form-control, .input-group > .form-select {
    background: #FAFAFA;
    border: none;
    border-radius: 0px;
}

.input-group:last-child {
    border-top: 1px solid #EDEDED;
}

.input-group input:focus {
    box-shadow: none;
}

.input-group input::placeholder {
    font-size: 14px;
}

.btn-form {
    background: #F9423E;
    color: white;
    border-radius: 100px;
    text-align: center;
    padding: 5px 40px;
    border: 0px;
    margin-left: auto;
    margin-right: auto;
}

.enlace-form a {
    color: #989898;
    font-size: 12px;
    text-decoration: none;
}

</style>
